import { render, staticRenderFns } from "./orderQuery.vue?vue&type=template&id=a5779342"
import script from "./orderQuery.vue?vue&type=script&lang=js"
export * from "./orderQuery.vue?vue&type=script&lang=js"
import style0 from "./orderQuery.vue?vue&type=style&index=0&id=a5779342&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports